import type { RouteRecordRaw } from 'vue-router'

export const partnerRouteName = {
  partnerRegistration: 'PartnerRegistration',
  partnerSignupConfirmation: 'PartnerSignupConfirmation',
} as const

const routes: RouteRecordRaw[] = [
  {
    name: 'PartnerSignup',
    path: '/me',
    component: () => import('src/components/ContentManager/index.vue'),
    children: [
      {
        component: () =>
          import('src/components/Auth/Partner/PartnerSignup.vue'),
        name: 'PartnerRegistration',
        path: '/partner-signup',
        meta: { title: 'Partner Signup' },
      },
      {
        component: () =>
          import('src/components/Auth/Partner/PartnerSignupConfirmation.vue'),
        name: 'PartnerSignupConfirmation',
        path: '/partner-signup-confirmation',
        meta: { title: 'Partner Signup' },
      },
    ],
  },
  {
    path: '/partner',
    name: 'PartnerPortal',
    component: () => import('src/components/Partner/index.vue'),
    redirect: () => ({ name: 'PartnerHomeRoute' }),
    children: [
      {
        name: 'PartnerHomeRoute',
        path: 'home',
        component: () => import('src/components/Partner/pages/Home/index.vue'),
        meta: {
          title: 'Partner Portal',
        },
      },
      {
        name: 'PartnerSpacesRoute',
        path: 'spaces',
        component: () =>
          import('src/components/Partner/pages/Spaces/index.vue'),
        meta: {
          title: 'Partner Portal - Spaces',
        },
      },
      {
        name: 'PartnerExtensionsRoute',
        path: 'apps',
        component: () =>
          import('src/components/Partner/pages/Extensions/index.vue'),
        meta: {
          title: 'Partner Portal - Extensions',
        },
      },
      // the title of this page is set on the mounted hook of BaseExtensionEditPage component
      {
        name: 'PartnerExtensionEditRoute',
        path: 'apps/:extensionId/edit',
        component: () =>
          import(
            'src/components/Partner/pages/Extensions/ExtensionEdit/index.vue'
          ),
      },
      {
        name: 'PartnerFieldtypesRoute',
        path: 'fields',
        component: () =>
          import('src/components/Partner/pages/Fieldtypes/index.vue'),
        meta: {
          title: 'Partner Portal - Fieldtypes',
        },
      },
      {
        name: 'PartnerFieldtypeEditor',
        path: 'fields/:fieldId',
        component: () =>
          import('src/components/Partner/pages/FieldTypesEditor/index.vue'),
        meta: {
          title: 'Partner Portal - Fieldtypes Editor',
        },
      },
      {
        name: 'PartnerTeamsRoute',
        path: 'team',
        component: () => import('src/components/Partner/pages/Team/index.vue'),
        meta: {
          title: 'Partner Portal - Team Management',
        },
      },
      {
        name: 'PartnerFinancesRoute',
        path: 'finances',
        component: () =>
          import('src/components/Partner/pages/Finances/index.vue'),
        meta: {
          title: 'Partner Portal - Finances',
        },
      },
      {
        name: 'PartnerDealsRoute',
        path: 'deals',
        component: () => import('src/components/Partner/pages/Deals/index.vue'),
        meta: {
          title: 'Partner Portal - Deals',
        },
      },
      // {
      //   name: 'PartnerPerksRoute',
      //   path: 'perks',
      //   component: () => import('src/components/Partner/pages/Perks/index.vue'),
      //   meta: {
      //     title: 'Partner Portal - Perks',
      //   },
      // },
      {
        name: 'PartnerSettingsRoute',
        path: 'settings/me',
        component: () =>
          import('src/components/Partner/pages/Settings/index.vue'),
        meta: {
          title: 'Partner Portal - Settings',
        },
      },
      {
        name: 'PartnerLearningRoute',
        path: 'resources/:type?',
        component: () =>
          import('src/components/Partner/pages/Learning/index.vue'),
        meta: {
          title: 'Partner Portal - Learning',
        },
      },
      {
        name: 'PartnerCourseRoute',
        path: 'resources/courses/:courseSlug',
        component: () =>
          import('src/components/Partner/pages/Learning/LessonStart/index.vue'),
        meta: {
          title: 'Partner Portal - Course Start',
        },
      },
      {
        name: 'PartnerCourseFinishedRoute',
        path: 'resources/courses/:courseSlug/done',
        component: () =>
          import('src/components/Partner/pages/Learning/LessonDone/index.vue'),
        meta: {
          title: 'Partner Portal - Course Finished',
        },
      },
      {
        name: 'PartnerCourseLessonRoute',
        path: 'resources/courses/:courseSlug/:lessonIndex',
        component: () =>
          import('src/components/Partner/pages/Learning/Lesson/index.vue'),
        meta: {
          title: 'Partner Portal - Course',
        },
      },
    ],
  },
]

export default routes
